export default function ErrorPage({ title = "Something unexpected happened", message = "We're sorry, but something went wrong. Please try again." } = {}) {
  const handleClick = () => {
    window.location.reload();
  };

  return (
    <>
      <main className="grid min-h-full w-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center bg-white shadow-sm p-8 rounded-lg">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{title}</h1>
          <p className="mt-6 text-base leading-7 text-gray-600 font-semibold max-w-2xl">
            {message}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <button
              onClick={handleClick}
              type="button"
              className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
              Retry
            </button>
          </div>
        </div>
      </main>
    </>
  );
}
